/* unplugin-vue-components disabled */import { render } from "./menu-point-list.vue?vue&type=template&id=21b3f875"
import script from "./menu-point-list.vue?vue&type=script&lang=js"
export * from "./menu-point-list.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__